import React from 'react';

import '../../styles/mfw.scss';
import { Link } from 'react-router-dom';


function MfwHome() {
    const image0='/images/MFW2025/Megan.jpg'; //MFW2025
    const image1= '/images/MFW2024/MaddalenaPloom.jpg'; //MFW 2024
    const image2= '/images/MFW2023/MFW2023_5.jpg';//MFW 2023
    const immagini = [
        { image: image0, title: ["Fashion Week 2025" ,""], className: "" , link: "/mfw2025" },
        { image: image1, title: ["Fashion Week 2024" ,""], className: "" , link: "/mfwfebruary" },
        { image: image2, title: ["Fashion Week 2023" ,""], className: "" , link: "/mfwseptember" },
        ];
        return (
            <section className="magazine">
              <div className="image-grid">
                {immagini.map((img, index) => (
                  <div key={index} className={`image-grid__item_home ${img.className}`}>
                    <Link to={img.link}>
                      <img src={img.image} alt={img.title.join(' ')} />
                      <h3 className="image-grid__title">
                        {img.title.map((line, i) => (
                          <span key={i}>
                            {line}
                            {i < img.title.length - 1 && <br />}
                          </span>
                        ))}
                      </h3>
                    </Link>
                  </div>
                ))}
              </div>
            </section>
            );
}

export default MfwHome;
